import { Interval } from '@tonaljs/tonal';
const majorKey = ["C3","Db3","D3","Eb3","E3","F3","Gb3","G3","Ab3","A3","Bb3","B3","C4","Db4","D4","Eb4","E4","F4","Gb4","G4","Ab4","A4","Bb4","B4","C5","Db5","D5","Eb5","E5","F5","Gb5","G5","Ab5","A5","Bb5","B5"];
const minorKey = ["A3","Bb3","B3","C3","C#3","D3","Eb3","E3","F3","F#3","G3","G#3","A4","Bb4","B4","C4","C#4","D4","Eb4","E4","F4","F#4","G4","G#4","A5","Bb5","B5","C5","C#5","D5","Eb5","E5","F5","F#5","G5","G#5"];

function getKeyTransposedBySemitones(keytonic, isMajor, semitones)
{
  return isMajor ? majorKey[(majorKey.indexOf(keytonic)+semitones)%36] : minorKey[(minorKey.indexOf(keytonic)+semitones)%36];
}

function getCurrentKey(currentKeyIndex, isMajor)
{
  if(currentKeyIndex<0){
    currentKeyIndex = 36+currentKeyIndex;
  }
  return isMajor ? majorKey[currentKeyIndex%36] : minorKey[currentKeyIndex%36];
}

function getKeyIndex(keytonic, isMajor)
{
  return isMajor ? majorKey.indexOf(keytonic) : minorKey.indexOf(keytonic) ;
}
/* 
function changeKeyIndex(interval, currentKeyIndex) {
    return (currentKeyIndex + Interval.get(interval).semitones) % 12;
} */

function transposeToInstrumentNoteKey(instrument, tonic, isMajor){
  if(instrument==='C'){
    return tonic;
  }
  let index = getKeyIndex(tonic, isMajor);
  switch(instrument){
    case "Bb":
      return getCurrentKey(index+2, isMajor);
    case "Eb":
      return getCurrentKey(index+9, isMajor);
    default:
      return tonic;
  }
}

/* function transposeMajorKeyToBbInstrument(tonic)
{
  return majorBb[majorKey.indexOf(tonic)];
}

function transposeMajorKeyToEbInstrument(tonic)
{
  return majorEb[majorKey.indexOf(tonic)];
} */

export { transposeToInstrumentNoteKey, getKeyTransposedBySemitones }